import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const FoodSearchModal = ({ isOpen, onClose, onAddFood, category }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedFood, setSelectedFood] = useState(null);

  const foodDatabase = [
  {
    id: 1,
    name: "Grilled Chicken Breast",
    image: "https://images.unsplash.com/photo-1613552496228-7992da79837d",
    imageAlt: "Grilled chicken breast with herbs on white plate with vegetables",
    calories: 165,
    protein: 31,
    carbs: 0,
    fats: 3.6,
    serving: "100g",
    category: "Protein"
  },
  {
    id: 2,
    name: "Brown Rice",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f54b2d5e-1765345169950.png",
    imageAlt: "Bowl of cooked brown rice with wooden spoon on rustic table",
    calories: 112,
    protein: 2.6,
    carbs: 24,
    fats: 0.9,
    serving: "100g",
    category: "Carbs"
  },
  {
    id: 3,
    name: "Avocado",
    image: "https://images.unsplash.com/photo-1713700999266-c9895677ed52",
    imageAlt: "Fresh avocado cut in half showing green flesh and brown seed",
    calories: 160,
    protein: 2,
    carbs: 8.5,
    fats: 14.7,
    serving: "100g",
    category: "Fats"
  },
  {
    id: 4,
    name: "Greek Yogurt",
    image: "https://images.unsplash.com/photo-1686182689848-283fdd34e72f",
    imageAlt: "Bowl of creamy Greek yogurt with berries and granola on top",
    calories: 59,
    protein: 10,
    carbs: 3.6,
    fats: 0.4,
    serving: "100g",
    category: "Protein"
  },
  {
    id: 5,
    name: "Salmon Fillet",
    image: "https://images.unsplash.com/photo-1650924168271-c41b44758db9",
    imageAlt: "Cooked salmon fillet with crispy skin on white plate with lemon",
    calories: 208,
    protein: 20,
    carbs: 0,
    fats: 13,
    serving: "100g",
    category: "Protein"
  },
  {
    id: 6,
    name: "Sweet Potato",
    image: "https://images.unsplash.com/photo-1585443835125-d85820a16e89",
    imageAlt: "Roasted sweet potato wedges with herbs on baking tray",
    calories: 86,
    protein: 1.6,
    carbs: 20,
    fats: 0.1,
    serving: "100g",
    category: "Carbs"
  }];


  const filteredFoods = searchQuery ?
  foodDatabase?.filter((food) =>
  food?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
  food?.category?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  ) :
  foodDatabase;

  const handleAddFood = () => {
    if (selectedFood) {
      onAddFood({ ...selectedFood, category });
      setSelectedFood(null);
      setSearchQuery('');
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="bg-card border border-border rounded-lg shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-4 md:p-6 border-b border-border">
          <div>
            <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
              Add Food to {category}
            </h2>
            <p className="text-sm caption text-muted-foreground mt-1">
              Search and select from our food database
            </p>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}>

            <Icon name="X" size={20} />
          </Button>
        </div>

        <div className="p-4 md:p-6 border-b border-border">
          <Input
            type="search"
            placeholder="Search foods..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e?.target?.value)}
            className="w-full" />

        </div>

        <div className="flex-1 overflow-y-auto p-4 md:p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {filteredFoods?.map((food) =>
            <button
              key={food?.id}
              onClick={() => setSelectedFood(food)}
              className={`flex items-start gap-3 p-4 rounded-lg border-2 transition-smooth hover-lift press-scale text-left ${
              selectedFood?.id === food?.id ?
              'border-primary bg-primary/5' : 'border-border bg-muted/50 hover:bg-muted'}`
              }>

                <div className="flex-shrink-0 h-16 w-16 rounded-lg overflow-hidden bg-background">
                  <Image
                  src={food?.image}
                  alt={food?.imageAlt}
                  className="h-full w-full object-cover" />

                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm md:text-base font-medium text-foreground mb-1">
                    {food?.name}
                  </p>
                  <p className="text-xs caption text-muted-foreground mb-2">
                    {food?.serving} • {food?.category}
                  </p>
                  <div className="flex items-center gap-3 text-xs caption text-muted-foreground">
                    <span>{food?.calories} kcal</span>
                    <span>P: {food?.protein}g</span>
                    <span>C: {food?.carbs}g</span>
                    <span>F: {food?.fats}g</span>
                  </div>
                </div>
                {selectedFood?.id === food?.id &&
              <Icon name="CheckCircle2" size={20} color="var(--color-primary)" />
              }
              </button>
            )}
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 p-4 md:p-6 border-t border-border">
          <Button
            variant="outline"
            onClick={onClose}>

            Cancel
          </Button>
          <Button
            variant="default"
            onClick={handleAddFood}
            disabled={!selectedFood}
            iconName="Plus"
            iconPosition="left">

            Add Food
          </Button>
        </div>
      </div>
    </div>);

};

export default FoodSearchModal;